import { useDispatch, useSelector } from "react-redux";
import Errormessages from "../../../../components/ErrorMessage/Errormessages";
import { RemoveProfileImageAction } from "../../../../redux/Action/ProfileAction";
import { useEffect } from "react";
let arr: any = []

const MyProfileImageItem = ({ onImageSelect, index, image, onImageRemove, setImageData, selectedImages, setDeletedImagesId, imageLength }: any) => {

    const dispatch = useDispatch<any>()
    const profile_data = useSelector((state: any) => state.SalonUpdateState)

    useEffect(() => {
        if (profile_data?.status) {
            arr = []
        }
    }, [profile_data])

    const handleRemoveImage = () => {
        onImageRemove(index);
    };

    const handleImage = (e: any, index: any) => {
        const newImage = e.target.files?.[0];
        const existingEntryIndex = arr.findIndex((item: any) => item.index === index);

        if (image?.media_id) {
            setDeletedImagesId((prevData: any) => {

                if (!prevData?.includes(image?.media_id)) {
                    return [...prevData, image?.media_id]
                } else {
                    return [...prevData]
                }
            })
        }

        if (existingEntryIndex !== -1) {
            arr[existingEntryIndex] = { index, newImage };
        } else {
            arr.push({ index, newImage });
        }
        let newArr: any = []
        let data = arr?.map((item: any) => {

            newArr.push(item?.newImage)
        })
        setImageData(newArr);
        onImageSelect(e, index);
    };


    return (
        <>
            {image?.file_path ? (
                <div className="imageupdated">
                    <figure>
                        <img src={typeof image?.file_path === "string" ? image?.file_path : URL.createObjectURL(image?.file_path)} />
                        {/* <button type='button' className='btn btnPhoto'><span className="icon-edit">
                            <input type='file' onChange={(e: any) => handleImage(e, index)} accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG" />
                        </span></button> */}
                        {imageLength >= 6 && <button type='button' className='btn btnDelete' onClick={handleRemoveImage}><span className="icon-delete"></span></button>}
                    </figure>
                </div>
            ) : (
                <div className='imageNOtupdated'>
                    <figure>
                        <span className="icon-upload"></span>
                        <input type='file' onChange={(e: any) => handleImage(e, index)} accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG" />
                    </figure>
                </div>
            )}
        </>
    );
};

export default MyProfileImageItem;
